<template>
    <div class="agreement">
        <div class="own-input">
            <label class="checkbox-container">
                <input
                    id="terms"
                    v-model="terms"
                    v-validate="'required'"
                    name="terms"
                    type="checkbox"
                    :data-vv-scope="scope">
                <span class="checkmark" />
            </label>
            <div
                class="text"
                v-html="$t('f_i_accept', [
                    $t('f_url_terms_and_conditions'),
                    $t('f_url_data_protection_policy'),
                    agreementUrl
                ])" />
        </div>
        <span class="error-message">{{ errors.first(`${scope}.terms`) }}</span>
    </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'round1/getComplaintField',
  mutationType: 'round1/UPDATE_COMPLAINT_FIELD'
})

export default {
  props: {
    scope: { type: String, required: true },
  },
  computed: {
    ...mapFields(['terms']),
    locale(){
      return this.$i18n.locale
    },
    agreementUrl() {
      return `https://www.sign-seal.com/user_agreement?locale=${this.locale}`
    }
  }
}
</script>

<style scoped lang="scss">
  .agreement {
    margin-top: 10px;
  }
  .agreement > .own-input {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    line-height: 29px;
    margin-bottom: 5px;

    label {
      margin-right: 20px;
    }

    .text {
      font-size: 14px;
      color: gray;
    }
  }


</style>

<style>
.agreement > .own-input .text a {
  color: #282828;
}


</style>